import type { Query } from "./search";

import { useSuspenseQuery } from "@tanstack/react-query";

import { buildSearchQuery } from "./search";
import { buildSingleQuery } from "./single";

export function useBooks(query: Query) {
  const result = useSuspenseQuery(buildSearchQuery(query));

  return result.data;
}

export function useBook(id: string) {
  const result = useSuspenseQuery(buildSingleQuery(id));

  return result.data;
}
